import ColorfulImage from './colorful-image';
export default ColorfulImage;
